<template>
  <el-card class="box-card" ref="card" shadow="never">
    <div class="d-flex-row justify-content-between">
      <span style="font-size: 18px;font-weight: bold;">各平台单量</span>
      <el-link type="primary" icon="el-icon-refresh" @click="getData">刷新</el-link>
    </div>
    <table-and-chart :year="year" :data="data" :chart-data="chartData" :chart-legend="chartLegend"
                     :organization-id="organizationId"
                     chart-id="ArtistPlatformCount" table-name="平台单量"/>
  </el-card>
</template>

<script>
import {getDashboardPlatformsData} from "@/api/dashboard";
import TableAndChart from "../detail/tableAndChart";

export default {
  name: "PlatformCount",
  components: {TableAndChart},
  props: {
    //是否限制范围
    isScope: {
      type: Boolean,
      default() {
        return false;
      }
    },
    year: [Number, String],
    organizationId: {
      type: [Number, String],
      default: 'ALL'
    },
    artistId: {
      type: [Number, String],
      default: 0
    },
    keyCustomerId: {
      type: [Number, String],
      default: 0
    },
    customerId: {
      type: [Number, String],
      default: 0
    },
    brandName: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      data: [],
      chartData: [],
      chartLegend: [],
    }
  },
  computed: {
    user() {
      return this.$store.getters.getUser
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.data = [];
      const params = {
        year: this.year,
        artist_id: this.artistId,
        customer_id: this.customerId,
        key_customer_id: this.keyCustomerId,
        brand_name: this.brandName,
        organization_id: this.organizationId,
        _field: 'order_count'
      }
      if (this.isScope) {
        params.user_id = this.user.id
      }
      getDashboardPlatformsData(params).then(res => {
        this.data = res.model.data;
        this.total_count = res.model.total_count;
        this.total_money = res.model.total_money;
        this.chartData = res.model.chart_data || [];
        this.chartLegend = res.model.chart_legend || []
      })
    },
  }
}
</script>

<style>

</style>
